export default __webpack_public_path__ + "static/media/wallet-43.892ca1f7.svg";